module.exports = __webpack_public_path__ + "media/application/images/wjc-blue@2x-8a658aca25d11e7aa6048ee0dd2b2879ff265d296d33e4231e0c8ad292ebd628.png";